import * as Yup from 'yup';

export interface AddResourceFormValues {
  name: string;
  type: 'file' | 'link';
  link?: string;
  file?: File;
  thumbnail?: File;
  category: string;
  agency: string;
}

export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must not exceed 100 characters'),
  type: Yup.string().oneOf(['file', 'link']).required('Type is required'),
  link: Yup.string().when('type', {
    is: 'link',
    then: (schema) => schema.required('Link is required').url('Invalid URL format'),
  }),
  file: Yup.mixed().when('type', {
    is: 'file',
    then: (schema) => schema.required('File is required'),
  }),
  thumbnail: Yup.mixed()
    .required('Thumbnail image is required')
    .test('is-file', 'Thumbnail image is required', (value) => {
      return value !== undefined && value !== null;
    }),
  category: Yup.string().required('Category is required'),
  agency: Yup.string().required('Agency is required'),
});

export const defaultValues: AddResourceFormValues = {
  name: '',
  type: 'link',
  link: '',
  category: '',
  agency: '',
};
